import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Mail, Lock, Shield } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Admin");
      navigate("/admin");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 relative" data-testid="admin-login-page">
      <div className="absolute inset-0 mandala-bg" />
      <form onSubmit={submit} className="relative z-10 w-full max-w-md glass-card-strong p-8 rounded-2xl">
        <div className="text-center mb-8">
          <Shield size={36} className="text-[#D4AF37] mx-auto mb-3" />
          <h1 className="font-serif-display text-4xl text-gold-gradient">Admin Portal</h1>
          <p className="text-xs tracking-[0.3em] uppercase text-[#D1C7C9] mt-2">Tulsi Restaurant</p>
        </div>

        <div className="space-y-4">
          <div className="flex items-center gap-3 px-3 py-2.5 rounded-md border border-[#3D1A21] bg-[#1A0B0E]/60 focus-within:border-[#D4AF37]">
            <Mail size={16} className="text-[#D4AF37]" />
            <input
              type="email"
              required
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-transparent outline-none text-sm text-[#FDFBF7] flex-1"
              data-testid="admin-email-input"
            />
          </div>
          <div className="flex items-center gap-3 px-3 py-2.5 rounded-md border border-[#3D1A21] bg-[#1A0B0E]/60 focus-within:border-[#D4AF37]">
            <Lock size={16} className="text-[#D4AF37]" />
            <input
              type="password"
              required
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-transparent outline-none text-sm text-[#FDFBF7] flex-1"
              data-testid="admin-password-input"
            />
          </div>
        </div>

        <button type="submit" disabled={loading} className="btn-saffron w-full justify-center mt-6 disabled:opacity-50" data-testid="admin-login-btn">
          {loading ? "Signing in..." : "Enter Admin"}
        </button>
      </form>
    </div>
  );
}
